import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';

import { RessourcesModule } from '@ressources/client/ressources.module';

class FaTransform {}

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [RessourcesModule],
    selector: 'app-stack-icons',
    styleUrl: './stack-icons.component.scss',
    templateUrl: './stack-icons.component.html',
})
export class StackIconsComponent {
    public readonly baseIcon = input.required<IconProp>();
    public readonly baseIconClass = input<string>();
    public readonly baseIconTransform = input<FaTransform>();
    public readonly clickable = input(false);
    public readonly size = input<SizeProp>('lg');
    public readonly stackClick = output<MouseEvent>();
    public readonly tooltip = input<string>();
    public readonly topIcon = input.required<IconProp>();
    public readonly topIconClass = input<string>();
    public readonly topIconTransform = input<FaTransform>();

    protected onClick(event: MouseEvent): void {
        if (!this.clickable()) {
            return;
        }

        this.stackClick.emit(event);
    }
}
